import { Box } from '@mui/material';
import { ReactElement } from 'react';
import AdministrationCard from './components/AdministrationCard';
import EmployeeManagementCard from './components/EmployeeManagementCard';
import RiskManagementCard from './components/RiskManagementCard';

// import UserDetailsForm from '../profile/components/UserDetailsForm';

const ManagementDetailPage = (): ReactElement => (
    <Box className="settings-management">
        <EmployeeManagementCard />
        <AdministrationCard />
        <RiskManagementCard />
    </Box>
);

export default ManagementDetailPage;
